<template>
    <div class="container pb-32">
        <PageIntro :title="$t('pages.how-to.title')" :subtitle="$t('pages.how-to.subtitle')" />
        <div class="relative flex items-center bg-grey-400 bg-opacity-25 pt-8 lg:pt-15 pb-8 lg:pb-18 px-4 lg:px-14">
            <div id="product-carousel" class="swiper">
                <h2 class="section-title mb-9 lg:mb-25 text-center">
                    <T t="locker_info.open" />
                </h2>
                <div class="swiper-wrapper">
                    <div
                        v-for="(step, i) in steps"
                        :key="`step-${i}`"
                        class="flex flex-col items-center justify-center swiper-slide"
                    >
                        <img
                            :src="require(`~/assets/images/illustrations/${step.img}`)"
                            :alt="step.title"
                            class="mb-9 lg:mb-12 w-32 lg:w-44 h-auto"
                        />
                        <h3 class="text-brand font-Open-Sans-Semibold text-sm lg:text-lg mb-6">
                            {{ i + 1 }} <span><T t="locker_info.step" /></span>
                        </h3>
                        <div
                            class="text-center tinymce-content lg:w-2/3 mb-9 lg:mb-36 text-sm lg:text-lg leading-5 lg:leading-6"
                            v-html="$t(step.description)"
                        ></div>
                    </div>
                </div>
            </div>

            <div class="absolute flex justify-between w-full px-4 lg:px-14 mb-15 lg:mb-0 lg:mt-6 left-0">
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
            <div class="w-full absolute bottom-4 lg:bottom-12 left-0">
                <div class="swiper-pagination swiper-pagination-clickable mx-auto"></div>
            </div>
        </div>
        <div
            class="relative flex items-center bg-grey-400 bg-opacity-25 pt-8 lg:pt-15 pb-8 lg:pb-18 px-4 lg:px-14 mt-9"
        >
            <div class="flex flex-col items-center justify-center swiper-slide">
                <h2 class="section-title mb-9 lg:mb-25 text-center">
                    <T t="locker_info.close" />
                </h2>
                <img
                    :src="require(`~/assets/images/illustrations/unlocking_illustration.png`)"
                    alt="Bezárás"
                    class="mb-9 lg:mb-12 w-32 lg:w-44 h-auto"
                />
                <div
                    class="text-center tinymce-content lg:w-2/3 mb-9 lg:mb-36 text-sm lg:text-lg leading-5 lg:leading-6"
                    v-html="$t('locker_info.close-instruction')"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Locker',
    data() {
        return {
            steps: [
                {
                    description: 'locker_info.instruction-step-1',
                    img: 'locking_illustration_step_1.png',
                },
                {
                    description: 'locker_info.instruction-step-2',
                    img: 'locking_illustration_step_2.png',
                },
                {
                    description: 'locker_info.instruction-step-3',
                    img: 'locking_illustration_step_3.png',
                },
                {
                    description: 'locker_info.instruction-step-4',
                    img: 'locking_illustration_step_4.png',
                },
            ],
        };
    },
    mounted() {
        this.carousel = new this.$swiper('#product-carousel', {
            slidesPerView: 1,
            spaceBetween: 48,
            resistance: true,
            speed: 750,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            loop: false,
            autoplay: {
                delay: 200000,
            },
        });
    },
    beforeDestroy() {
        this.carousel.destroy();
    },
};
</script>
